const ENVIRONMENTS = {
  dev: 'https://dev.api.smart.juganu.com',
  staging: 'https://staging.api.smart.juganu.com',
  prod: 'https://prod.api.smart.juganu.com'
};

// Google Maps Map ID (cloud styling)
// Note: Map IDs are not secrets, but the API key should be restricted in GCP.
const DEFAULT_GOOGLE_MAPS_MAP_ID = '539b6d99968d4ce117eeb50f';

const config = {
  // Google Maps configuration
  // You can override in browser console:
  // localStorage.setItem('googleMapsMapIdDark', '<your-dark-map-id>');
  // localStorage.setItem('googleMapsMapIdLight', '<your-light-map-id>');
  // Or via env:
  // REACT_APP_GOOGLE_MAPS_MAP_ID_DARK / REACT_APP_GOOGLE_MAPS_MAP_ID_LIGHT
  get googleMapsMapIdDark() {
    return (
      localStorage.getItem('googleMapsMapIdDark') ||
      process.env.REACT_APP_GOOGLE_MAPS_MAP_ID_DARK ||
      DEFAULT_GOOGLE_MAPS_MAP_ID
    );
  },
  get googleMapsMapIdLight() {
    return (
      localStorage.getItem('googleMapsMapIdLight') ||
      process.env.REACT_APP_GOOGLE_MAPS_MAP_ID_LIGHT ||
      DEFAULT_GOOGLE_MAPS_MAP_ID
    );
  },
  get apiBaseUrl() {
    const env = localStorage.getItem('environment') || 'dev';
    return ENVIRONMENTS[env];
  },
  get apiNmsUrl() {
    return `${this.apiBaseUrl}/api/v1/nms`;
  },
  get apiLmsUrl() {
    return `${this.apiBaseUrl}/api/v1/light`;
  },
  // Backend/API Gateway that proxies access to the central monitoring project
  // (e.g. Cloud Function behind Apigee). Override in browser if needed:
  // localStorage.setItem('monitoringApiBaseUrl', 'https://<your-host>');
  get apiMonitoringBaseUrl() {
    return localStorage.getItem('monitoringApiBaseUrl') || this.apiBaseUrl;
  },
  get apiMonitoringUrl() {
    return `${this.apiMonitoringBaseUrl}/api/v1/monitoring`;
  },
  get apiUrl() {
    return `${this.apiBaseUrl}/api/v1`;
  },
  setEnvironment(env) {
    if (!ENVIRONMENTS[env]) {
      throw new Error(`Invalid environment: ${env}`);
    }
    localStorage.setItem('environment', env);
  },
  getEnvironment() {
    return localStorage.getItem('environment') || 'dev';
  }
};

export default config;

